import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, Crud, CrudService, CustomHttp } from '../../../core';
import { Nota } from '../nota';

@Injectable({
    providedIn: 'root'
})
export class NotaCrudHttpService implements Crud<Nota> {
    resource = 'nota';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Procura uma única nota através do seu ID */
    find(id: number): Observable<Nota> {
        return this.crudService.find<Nota>(this.resource, id);
    }

    /** Carrega uma única nota através do seu ID */
    load(id: number): Observable<Nota> {
        return this.crudService.load<Nota>(this.resource, id);
    }

    /** Insere uma nova nota */
    insert(entity: Nota): Observable<Nota> {
        return this.crudService.insert<Nota>(this.resource, entity);
    }

    /** Altera uma nota existente */
    update(entity: Nota): Observable<Nota> {
        return this.crudService.update<Nota>(this.resource, entity);
    }

    /** Exclui uma nota através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
